/* eslint-disable no-empty-pattern */
import { Dropdown, Modal, Nav } from 'react-bootstrap';
import ProfileDropdownMenu from './ProfileDropdownMenu';
import NotificationDropdownMenu from './NotificationDropdownMenu';
import { useAppContext } from 'providers/AppProvider';
import { Link, useNavigate } from 'react-router-dom';
import ThemeToggler from 'components/common/ThemeToggler';
import { useState } from 'react';
import DropdownSearchBox from 'components/common/DropdownSearchBox';
import SearchResult from 'components/common/SearchResult';
import FeatherIcon from 'feather-icons-react';
import {
  useMarkAllNotificationsRead,
  useMarkNotificationRead,
  useNotificationList,
  useUnreadNotificationCount
} from 'hooks/useNotifications';
import { TNotification } from 'utils/types';

interface NavItemsProps {
  initials?: string;
}
const NavItems = ({ initials }: NavItemsProps) => {
  const {
    config: {}
  } = useAppContext();
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { data: unreadCount = 0 } = useUnreadNotificationCount();
  const { data: notificationPage, isLoading: notificationsLoading } =
    useNotificationList(notificationDropdownOpen);
  const markNotificationRead = useMarkNotificationRead();
  const markAllNotificationsRead = useMarkAllNotificationsRead();

  const handleNotificationClick = (notification: TNotification) => {
    if (!notification.isRead) {
      markNotificationRead.mutate(notification.notificationId);
    }
    if (notification.url) {
      navigate(notification.url);
    }
    setNotificationDropdownOpen(false);
  };

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      <Nav.Item>
        <ThemeToggler className="px-2" />
      </Nav.Item>
      <Nav.Item>
        <Dropdown
          autoClose="outside"
          show={notificationDropdownOpen}
          onToggle={nextShow => setNotificationDropdownOpen(!!nextShow)}
        >
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link position-relative"
            variant=""
          >
            <FeatherIcon icon="bell" size={20} />
            {unreadCount > 0 && (
              <span
                className="badge rounded-pill bg-danger"
                style={{
                  position: 'absolute',
                  top: 2,
                  right: -4,
                  minWidth: '1.15rem',
                  height: '1.15rem',
                  padding: '0 4px',
                  fontSize: '0.625rem',
                  lineHeight: '1.15rem'
                }}
              >
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </Dropdown.Toggle>
          <NotificationDropdownMenu
            notifications={notificationPage?.notifications ?? []}
            isLoading={notificationsLoading}
            onItemClick={handleNotificationClick}
            onMarkAllRead={() => markAllNotificationsRead.mutate()}
            unreadCount={unreadCount}
          />
        </Dropdown>
      </Nav.Item>
      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
            <div
              className="rounded-circle"
              style={{
                background: '#3e465b',
                padding: '.5rem',
                paddingLeft: initials ? '.5rem' : '.6rem',
                paddingRight: initials ? '.5rem' : '.6rem',
                color: 'white'
              }}
            >
              {initials || 'U'}
            </div>
          </Dropdown.Toggle>
          <ProfileDropdownMenu />
        </Dropdown>
      </Nav.Item>
      <Modal
        show={openSearchModal}
        onHide={() => setOpenSearchModal(false)}
        className="search-box-modal mt-15"
      >
        <Modal.Body className="p-0 bg-transparent">
          <DropdownSearchBox
            className="navbar-top-search-box"
            inputClassName="rounded-pill"
            size="lg"
            style={{ width: 'auto' }}
          >
            <SearchResult />
          </DropdownSearchBox>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NavItems;
